module.exports = __webpack_public_path__ + "static/media/guang.29d17b94.png";